











export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
  computed: {
    linkClass() {
      return this.link.includes("signin") ? "link-login" : "";
    },
  },
};
